export default __webpack_public_path__ + "static/media/twist-new-logo.25535bd0.png";